// TODO: refactor jQuery --> ES
export default class Filter {
	constructor(app) {
		this.app = app;
		const self = this;

		this.toggleFilterDetails();

		this.defaultfiltername = "default"; //default filtername if missing


		//apply filter
		$(".js_filterbtn").on("click", function (e) {
			e.preventDefault();
			window.location = self.buildFilter()
		});

		//more filter
		$(".js-filter-more-btn").on("click", function (e) {
			$(".filterGroupList").find(".js-filter-more-btn").removeClass("is-active")
			$(".filterGroupList").find(".filterGroup").addClass("is-active")
		});

		$(".js_filter").on("change", function (e) {
			$(".js_filterbtn").click()
		});

		//order filter
		$(".js_orderby").on("change", function (e) {
			$(".js_filterbtn").click()
		});


		//remove filter
		$(".js-removeselection").on("click", function (e) {
			e.preventDefault();

			let k = $(this).data("key");
			let v = $(this).data("value");
			k = k.toString().replace(/\+/g, "\\+");
			v = v.toString().replace(/\+/g, "\\+");
			let element = $("*[name=" + k + "][value=" + v + "]")

			if (!!element && element.length > 0) { //check und radioboxen

				if (element.prop("type") == "checkbox" || element.prop("type") == "radio") {
					element.prop("checked", false)
				} else { //inputs
					element.val("")
				}
			} else { //selectboxen
				element = $("*[name=" + k + "]").find("option[value=" + v + "]");
				if (!!element && element.length > 0) {
					element.prop("selected", false)
				}
			}

			window.location = self.buildFilter()
		})
	}

	toggleFilterDetails() {
		const btn = document.querySelector('.js-filter-details-btn');
		if (btn === null)
			return;
		const txt = btn.querySelector('.js-txt');
		const details = document.querySelector('.js-filter-details');
		btn.addEventListener('click', e => {
			const isActive = details.classList.toggle('is-active');
			btn.classList.toggle('is-expanded', isActive);
			if (isActive) {
				txt.textContent = btn.dataset.txtLess;
			} else {
				txt.textContent = btn.dataset.txtMore;
			}
		});
	}

	buildFilter() {
		const self = this;
		let cpath = $(location).prop("href");
		let filter = {};
		$(".js_filter").each(function () {
			let name = $(this).prop("name");
			let value = $(this).val();

			if (self.app.info.isDebug) {
				console.log(value)
				console.log($(this).prop('checked'))
			}
			if (
				($(this).prop("type") == "checkbox" && !!$(this).prop('checked')) ||
				($(this).prop("type") == "radio" && !!$(this).prop('checked')) ||
				($(this).prop("type") != "checkbox" && $(this).prop("type") != "radio" && !!value && value != "none")
			) {

				if (self.app.info.isDebug) {
					console.log(name)
					console.log(value)
					console.log($(this).prop("type"))
				}


				let curname = $(this).prop("name").replace(/\+/g, "\\+"); // escape f* plus sign

				if ($(".js_filter.js_range[id=" + curname + "]").val() == "none") { //range only max filtering
					value = "." + value
				}
				if ($(".js_filter.js_range[id=" + curname + "_2]").val() == "none") { //range only max filtering
					value = value + "."
				}
				if (!(name in filter)) {
					filter[name] = [value]
				} else {
					let d = filter[name];
					d.push(value);
					filter[name] = d
				}
			}
		});

		if (self.app.info.isDebug) {
			console.log(filter);
		}

		let cpathObj = cpath.split("?");
		let cpathTail = "";
		if (cpathObj.length === 2) {
			cpathTail = "?" + cpathObj[1].replace(/page=([0-9]{1,2})/, "page=0");
		}

		cpath = cpathObj[0]

		let newfilter = cpath.replace(/(.*)(\~_.*?)([\/|-].*)/, "" + "$2" + "");

		if (!newfilter.includes("~_")) {
			newfilter = "~_" + this.defaultfiltername
		}

		$.each(filter, function (k, v) {
			let f = k + "_" + v.join(".");
			newfilter += "-" + f
		});
		let npath = newfilter + cpathTail;

		return npath
	}
}
